import { render, staticRenderFns } from "./single.vue?vue&type=template&id=17889666&"
import script from "./single.vue?vue&type=script&lang=js&"
export * from "./single.vue?vue&type=script&lang=js&"
import style0 from "./single.vue?vue&type=style&index=0&id=17889666&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports